import { Group, Radio } from '@mantine/core';

interface YesNoRadioGroupProps {
  value: boolean | undefined;
  onChange: (next: boolean) => void;
}

export function YesNoRadioGroup({ value, onChange }: YesNoRadioGroupProps) {
  return (
    <Group mt="xs">
      <Radio
        label="Yes"
        value="true"
        checked={value === true}
        onChange={() => onChange(true)}
      />
      <Radio
        label="No"
        value="false"
        checked={value === false}
        onChange={() => onChange(false)}
      />
    </Group>
  );
}
